module.exports = __webpack_public_path__ + "img/CY110012.53f6803f.png";